<div class="container__main container__main--full">
    <div class="col-xxs-12">
        <msc-timeline [context]="'course'" [contextId]="instance.id"></msc-timeline>
    </div>
</div>
